import { useGLTF } from '@react-three/drei';
import * as logger from '../utils/logger';

export const useCustomGltf = ( url, onProgress = null) => {
	const dracoPath = 'draco/';

	//IMPORTANT! useGLTF caches the model based on URL, after model is loaded for first time, calling this hook will not trigger onLoad event!
	const gltf = useGLTF(url, dracoPath, true,
		//customizing the loader because the useProgress from drei doesn't work well.
		(loader) => {
			const orgLoad = loader.load;

			loader.load = (url, onLoad, orgOnProgress, onError) => {
				logger.debug('[d8s renderer]: loading model url: ' , url);
				const customOnProgress = (...args) => {
					onProgress?.(...args);
					orgOnProgress?.(...args);
				};

				const onCustomLoad = (...args) => {
					const gltf = args[0];
					gltf._d8sLoaded = true;
					gltf._d8sUrl = url;
					logger.debug('[d8s renderer]: loaded done model url: ' , url);
					onLoad?.(...args);
				};

				orgLoad.call(loader, url, onCustomLoad, customOnProgress, onError);
			};
		});

	return gltf;
};
